import React from 'react';
import './TimeOffRequestForm.scss';
import { FormLabel } from '../common/forms/FormElements';
import { isReadOnly } from './TimeOffRequest';
import { FormGroup, Input } from 'reactstrap';

export default class TimeOffNotes extends React.Component {
    onTimeOffReasonChanged = (e) => {
        if (!e || !e.id) {
            return;
        }

        const { timeOffRequest, onTimeOffRequestMutated } = this.props;

        timeOffRequest.timeOffReasonId = e.id;

        onTimeOffRequestMutated(timeOffRequest);
    };

    render() {
        const { loading, timeOffRequest, onTimeOffRequestMutated } = this.props;

        if (loading) {
            return null;
        }

        const readOnly = isReadOnly(timeOffRequest);

        return (
            <FormGroup className="tor-form-group">
                <FormLabel text="Notes" />

                <Input
                    type="textarea"
                    maxLength={500}
                    max={500}
                    value={timeOffRequest.notes}
                    readOnly={readOnly}
                    onChange={(e) => {
                        timeOffRequest.notes = e.target.value;

                        onTimeOffRequestMutated(timeOffRequest);
                    }}
                />
            </FormGroup>
        );
    }
}
